import { z } from "zod";

export const selectArticlesSchema = z.object({
	articleIds: z.array(z.uuid()).min(1, "At least one article must be selected"),
});

export type SelectArticlesSchema = z.infer<typeof selectArticlesSchema>;
